import * as React from "react";

const SvgIcnParticipant = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 10 10" {...props}>
        <path
            d="M5 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM.974 9.658A.468.468 0 01.501 10c-.427 0-.563-.396-.475-.658C.763 7.13 2.458 6 5 6c2.542 0 4.237 1.13 4.974 3.342.088.262-.031.657-.474.658-.28 0-.407-.14-.474-.342C8.429 7.87 7.126 7 5 7 2.875 7 1.57 7.87.974 9.658z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnParticipant;

SvgIcnParticipant._raw = `
<svg width="1em" height="1em" viewBox="0 0 10 10" >
        <path
            d="M5 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM.974 9.658A.468.468 0 01.501 10c-.427 0-.563-.396-.475-.658C.763 7.13 2.458 6 5 6c2.542 0 4.237 1.13 4.974 3.342.088.262-.031.657-.474.658-.28 0-.407-.14-.474-.342C8.429 7.87 7.126 7 5 7 2.875 7 1.57 7.87.974 9.658z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth="1"
        />
    </svg>`;
